<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">广告信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <div style="width:500px">
          <el-form-item label="广告名称" prop="advName">
            <el-input v-model="form.advName" placeholder="请输入广告名称" style="width:100%" />
          </el-form-item>
          <el-form-item label="广告类型" prop="advType">
            <el-radio-group v-model="form.advType" style="width:100%" @change="changeClick">
              <el-radio :label="0">图片广告</el-radio>
              <el-radio :label="1">文字广告</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="isShow" label="广告内容" prop="advContent">
            <el-input v-model="form.advContent" type="textarea" :rows="4" placeholder="请输入广告内容" style="width:100%" />
          </el-form-item>
          <el-form-item label="广告位置" prop="advLocation">
            <el-select v-model="form.advLocation" placeholder="请选择广告位置" style="width:100%">
              <el-option v-for="item in adLocation" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="投放地域" prop="putArea">
            <div class="border">
              <STree v-model="form.putArea" :data="datatree" style="width:100%;" />
            </div>
          </el-form-item>
          <!-- <el-form-item label="投放渠道" prop="putWay">
              <STree v-model="form.putWay" :data="datatree1" style="width:400px;"></STree>
            </el-form-item> -->
          <el-form-item label="广告主" prop="advEr">
            <el-input v-model="form.advEr" placeholder="请输入广告主" style="width:100%" />
          </el-form-item>
          <el-form-item v-if="!isShow" label="广告图片" prop="advPicture">
            <el-upload v-model="form.advPicture" class="avatar-uploader" :action="action" :headers="headers" style="width:100%" :show-file-list="false" :on-success="handleAvatarSuccess" :on-remove="handleRemove" :before-upload="beforeAvatarUpload" accept=".jpg, .jpeg, .png,">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <span v-if="imageUrl" class="el-upload-action" @click.stop="handleRemove()">
                <i class="el-icon-delete" />
              </span>
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </el-form-item>
          <el-form-item label="广告跳转" prop="urlType">
            <el-radio-group v-model="form.urlType" style="width:100%;" @change="clickChangeUrl">
              <el-radio label="0">无跳转</el-radio>
              <el-radio label="1">活动</el-radio>
              <el-radio label="2">链接地址</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="showJumpUrl" label="链接地址" prop="jumpConnection">
            <el-input v-model="form.jumpConnection" placeholder="请输入链接地址" style="width:100%" />
          </el-form-item>
          <el-form-item v-show="showActivity" label="活动" prop="activityUrl">
            <el-select v-model="form.activityUrl" placeholder="请选择需要跳转的广告" style="width:100%">
              <el-option v-for="item in activityList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="投放时间" prop="date">
            <el-date-picker v-model="form.date" type="datetimerange" style="width:100%" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item label="展示优先级" prop="showPriority">
            <el-input v-model="form.showPriority" style="width:100%" placeholder="请输入优先级" maxlength="2" @input="checkPriority" />
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'Xiugaiguanggao',
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
        }
      },
      showJumpUrl: false,
      showActivity: false,
      activityList: [],
      form: {
        advName: '',
        advType: 0,
        urlType: '',
        activityUrl: '',
        advContent: '',
        advLocation: '',
        date: [],
        advPicture: '',
        advEr: '',
        putArea: [],
        putWay: [],
        jumpConnection: '',
        showPriority: ''
      },
      rules: {
        advName: [{
          required: true,
          message: '请输入广告名称',
          trigger: 'blur'
        }],
        advType: [{
          required: true,
          message: '请选择广告类型',
          trigger: 'blur'
        }],
        advContent: [{
          required: true,
          message: '请输入广告内容',
          trigger: 'blur'
        }],
        advLocation: [{
          required: true,
          message: '请选择广告位置',
          trigger: 'blur'
        }],
        advPicture: [{
          required: true,
          message: '请上传广告图片',
          trigger: 'blur'
        }],
        date: [{
          required: true,
          message: '请选择广告投放时间',
          trigger: 'blur'
        }]
      },
      datatree: [],
      datatree1: [],
      adLocation: [{
        value: '0',
        label: '首页'
      },
      {
        value: '1',
        label: '首页弹窗'
      },
      {
        value: '2',
        label: '充电界面'
      },
      {
        value: '3',
        label: '加载页广告'
      }
      ],
      isShow: false,
      imageUrl: '',
      id: '',
      token: window.localStorage.getItem('token')
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  mounted() {
    this.getDataDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
    this.getArea()
    // this.getOrg()
    this.getActivityList()
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    checkPriority(_value) {
      _value = _value.replace(/^(0+)|[^\d]+/g, '')
      this.form.showPriority = _value
    },
    changeClick(val) {
      console.log(val)
      if (val === 0) {
        this.isShow = false
        this.adLocation = [
        {
          value: '0',
          label: '首页'
        },
        {
          value: '1',
          label: '首页弹窗'
        },
        {
          value: '2',
          label: '充电界面'
        },
        {
          value: '3',
          label: '加载页广告'
        }
        ]
        this.form.advContent = ''
      } else if (val === 1) {
        this.isShow = true
        this.adLocation = [{
         value: '0',
        label: '首页'
      },
      // {
      //   value: '1',
      //   label: '首页弹窗'
      // },
      {
        value: '2',
        label: '充电界面'
      }
        ]
        this.form.advPicture = ''
      }
      this.form.advLocation = this.adLocation[0].value
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.form.advPicture = res.data.fileName
    },
    handleRemove() {
      this.imageUrl = ''
      this.form.advPicture = ''
    },
    beforeAvatarUpload(file) {
      // if (!(file.type === "image/png" || file.type === "image/gif" || file.type === "image/jpg" || file.type === "image/jpeg")) {
      //   this.$notify.warning({
      //     title: "警告",
      //     message:
      //       "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片"
      //   });
      // }
      const isJPG = (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')
      const isLt2M = file.size <= 2097152

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JEPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    clickChangeUrl(val) {
      if (val === '1') {
        this.showJumpUrl = false
        this.showActivity = true
      } else if (val === '2') {
        this.showJumpUrl = true
        this.showActivity = false
      } else {
        this.showJumpUrl = false
        this.showActivity = false
      }
    },

    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }

      if (this.form.jumpConnection && this.form.jumpConnection !== '') {
        var strRegex = '((https?|ftp|file)://|www.)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]'
        var re = new RegExp(strRegex)
        if (!re.test(this.form.jumpConnection)) {
          this.$message.error('链接地址格式错误!')
          return false
        }
      }
      if (this.form.urlType === '1') {
        if (!this.form.activityUrl || this.form.activityUrl === '') {
          this.$message.error('请选择分享活动!')
          return false
        }
      }
      if (!this.form.putArea || this.form.putArea.length < 1) {
        this.$message.error('请选择投放地域!')
        return false
      }
      const area = this.form.putArea.join(',')
      // let way = this.form.putWay.join(",")
      let jumpConnection = ''
	  let activityType = ''
      if (this.form.urlType === '0') {
        jumpConnection = ''
      } else if (this.form.urlType === '1') {
        // 分享广告跳转地址
        const arr = this.form.activityUrl.split(',')
        jumpConnection = arr[0]
        activityType = arr[1]
      } else {
        // 普通跳转地址链接
        jumpConnection = this.form.jumpConnection
      }
      const data = {
        advName: this.form.advName,
        advType: this.form.advType,
        advContent: this.form.advContent,
        advLocation: this.form.advLocation,
        putArea: area,
        // putWay: way,
        putWay: '',
        advEr: this.form.advEr,
        jumpConnection: jumpConnection,
        activityType: activityType,
        jumpType: this.form.urlType,
        advPicture: this.form.advPicture,
        deliveryStart: this.form.date[0],
        deliveryEnd: this.form.date[1],
        showPriority: this.form.showPriority,
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/advertising/post',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
          this.$router.go(-1)
        }
      })
    },

    cancel() {
      this.$router.go(-1)
    },

    getArea() {
      this.$store.dispatch('form/handle', {
        url: '/business/advertising/getAreaTree',
        method: 'get',
        callback: resp => {
          console.log(resp)
          this.datatree = resp
        }
      })
    },

    // getOrg() {
    //   this.$store.dispatch("form/handle", {
    //     url: "/business/advertising/getOrgTree",
    //     method: "get",
    //     callback: resp => {
    //       console.log(resp)
    //       this.datatree1 = resp;
    //     }
    //   });
    // },
    getActivityList() {
      this.$store.dispatch('form/handle', {
        url: '/activity/page?pageSize=-1&pageNo=1&status=1,2&type=5,7',
        method: 'get',
        callback: resp => {
          console.log(resp)
          resp.list.forEach(element => {
            this.activityList.push({ 'label': element.name, 'value': String(element.id) + ',' + element.type })
          })
        }
      })
    },
    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/business/advertising/detail',
        data: data,
        method: 'get',
        callback: resp => {
          console.log(resp)

          if (resp.advType === 0) {
            this.isShow = false
          } else if (resp.advType === 1) {
            this.isShow = true
          }
          this.form.advName = resp.advName
          this.form.advType = resp.advType
          this.form.advContent = resp.advContent
          this.form.advLocation = resp.advLocation
          this.form.advEr = resp.advEr

          if (resp.jumpType === '1') {
            this.showJumpUrl = false
            this.showActivity = true
            this.form.activityUrl = resp.jumpConnection + ',' + resp.activityType
          } else if (resp.jumpType === '2') {
            this.showJumpUrl = true
            this.showActivity = false
            this.form.jumpConnection = resp.jumpConnection
          } else {
            this.showJumpUrl = false
            this.showActivity = false
          }
          this.form.urlType = resp.jumpType

          this.form.advPicture = resp.advPicture
          this.form.date = [resp.deliveryStart, resp.deliveryEnd]
          this.form.showPriority = resp.showPriority
          this.form.putArea = resp.putArea.split(',')
          // this.form.putWay = resp.putWay.split(",")
          this.imageUrl = HOST + '/oss?objectName=' + resp.advPicture + '&token=' + this.token
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-upload-action {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0;
  color: #fff;
  text-align: center;
  line-height: 120px;

}

.el-upload-action:hover {
  font-size: 20px;
  background-color: #000;
  background-color: rgba(0, 0, 0, .3)
}
.border{
  border: 1px solid #EEEEEE;
  padding: 20px;
  height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/adManagement/reviseAd.vue